






























































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RecebimentoStore from '@/components/Recebimento/Store/RecebimentoStore'
import Theme from '@/styles/Theme'
import { RecebimentoItem } from '@/types/_'
import { maskDate } from '@/utils/common'
import _ from 'lodash'

@Component

export default class ComponentRecebimentoDetalhe extends Vue {
  @Prop() recebimentoItem: RecebimentoItem

  activeDisplay: boolean = false

  get getActiveDisplay() {
    return this.activeDisplay
  }

  set getActiveDisplay(value: boolean) {
    this.activeDisplay = value
    this.ga(`recebimento-detalhe-item-${value ? 'aberto' : 'fechado'}`)
  }

  get getRecebimentoItem() {
    return this.recebimentoItem
  }

  get getRecebimentoStore() {
    return getModule(RecebimentoStore, this.$store)
  }

  get getTheme() {
    return Theme
  }

  lowerCase(value: string) {
    return _.toLower(value)
  }

  capitalizeCase(value: string) {
    return _.startCase(_.toLower(value))
  }

  formatDate(value: string) {
    return maskDate(value)
  }

  tipoItem(valor) {
    switch (valor) {
      case '0':
        return true
      case '1':
        return false
      default:
        return true
    }
  }

  ga(filtroItem) {
    this.$ga.event('recebimento', filtroItem, this.$user.profile.email)
  }
}
